// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ufnx","left":"styles_left__1Ev_u"};